var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"cta-content-downloadable"}},[_c('CTABanner',{attrs:{"onlyBanner":true,"bannerData":{bannerText: 'SEE SIGN UP', href:'/sign-up'}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }